import { Link } from 'react-router-dom'

interface BlogLinkProps {
  slug: string
  children: React.ReactNode
}

/**
 * Inline link to another blog article. Used for cross-article internal linking
 * (SEO — helps Google understand topical relationships between articles).
 */
export function BlogLink({ slug, children }: BlogLinkProps) {
  return (
    <Link
      to={`/blog/${slug}`}
      className="text-primary font-semibold hover:underline underline-offset-2 decoration-primary/40"
    >
      {children}
    </Link>
  )
}
